// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconPresentationProps, IconWrapper } from "@insite/mobius/Icon";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ClickablePresentationProps } from "@pace/MobiusOverrides/Clickable/Clickable";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

export interface HeaderAccountWarehouseInfoSharedStyles {
    shipToAddressClickable?: ClickablePresentationProps;
    titleTypography?: TypographyPresentationProps;
    titleLabelTypography?: TypographyPresentationProps;
    titleIcon?: IconPresentationProps;
    wrapper?: InjectableCss;
    titleClickable?: ClickablePresentationProps;
}

const headerAccountWarehouseInfoSharedStyles: HeaderAccountWarehouseInfoSharedStyles = {
    shipToAddressClickable: {
        css: css`
            ${xScreen("lte", "sm")} {
                display: flex;
                flex-wrap: wrap;
                width: 100%;
            }
            &:hover ${IconWrapper} {
                color: ${color("common.ui8")};
            }
        `,
    },
    titleTypography: {
        size: 12,
        lineHeight: "17px",
        weight: fontConfig.weight.regular,
        color: "common.ui7",
        ellipsis: true,
        css: css`
            max-width: 330px;
            position: relative;
            padding-right: 20px;
            ${xScreen("lte", "sm")} {
                max-width: 100%;
                padding-right: 0;
                white-space: normal;
            }
        `,
    },
    titleLabelTypography: {
        size: 12,
        lineHeight: "17px",
        weight: fontConfig.weight.bold,
        color: "common.ui14",
        css: css`
            margin-right: 4px;
        `,
    },
    titleIcon: {
        css: css`
            margin-left: 8px;
            color: ${color("common.ui14")};
            width: auto;
            &,
            svg {
                height: auto;
                width: 12px;
            }
            ${xScreen("lte", "sm")} {
                color: ${color("secondary")};
                &,
                svg {
                    width: 14px;
                }
            }
        `,
    },
    wrapper: {
        css: css`
            display: inline-flex;
            max-width: 30%;
            align-items: center;
            position: relative;
            &&& {
                width: 500px;
                ${xScreen("lte","md")} {
                    width: 100%;
                }
            }
            &:hover {
                ${IconWrapper} {
                    color: ${color("common.ui8")};
                }
            }
            ${xScreen("lte","md")} {
                max-width: 100%;
            }
        `,
    },
    titleClickable: {
        css: css`
            position: absolute;
            right: 0;
            top: 8px;
            z-index: 1;
        `,
    },
};

export default headerAccountWarehouseInfoSharedStyles;
